import MouvementsTab from "@features/stock/components/MouvementsTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/mouvements/")({
  component: MouvementsTab,
});
